import { render, staticRenderFns } from "./AssignEmployee.vue?vue&type=template&id=0463dd40&scoped=true&"
import script from "./AssignEmployee.vue?vue&type=script&lang=js&"
export * from "./AssignEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463dd40",
  null
  
)

export default component.exports